let notificationApi = null

export const setNotificationApi = (api) => {
  notificationApi = api || null
}

const normalizeConfig = (config) => {
  if (!config || typeof config !== 'object') {
    return config
  }
  const { message, title, ...rest } = config
  if (message !== undefined && title === undefined) {
    return { ...rest, title: message }
  }
  return config
}

const invoke = (method, config) => {
  const normalized = normalizeConfig(config)
  if (notificationApi && typeof notificationApi[method] === 'function') {
    return notificationApi[method](normalized)
  }
  return undefined
}

const METHODS = ['success', 'error', 'info', 'warning', 'open', 'destroy']

export const notification = new Proxy(
  {},
  {
    get(_, method) {
      if (typeof method === 'string' && METHODS.includes(method)) {
        return (config) => invoke(method, config)
      }
      return undefined
    },
  }
)

export const notifyError = (config = {}) => {
  invoke('error', config)
}

export default notification
